import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Fuse from "fuse.js";
import { EventBus } from "@/main";
import router from "../router";
import cart from "./modules/cart.js";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        session: JSON.parse(localStorage.getItem("session")),

        authenticated: false,

        criterion: null,

        results: [],

        acount: {
            token: null,

            user: {},

            rols_ids: [],
        },

        ui: {
            getingShippingMethods: true,
            purchaceordersGeting: true,
            tokenRefreshDialog: false,
            getingCategories: true,
            articlesGeting: true,
            productsGeting: true,
            colorGeting: true,
            error: null,
        },

        colors: [],

        filters: [],

        articles: [],

        products: [],

        customers: [],

        categories: [],

        purchaceorders: [],

        articles_index: [],

        type_of_finishes: [],

        shipping_methods: [],

        sales_order_last_id: null,
    },

    getters: {
        getColors: (state) => state.colors,

        auth: (state) => state.authenticated,

        getArticles: (state) => state.articles,

        getToken: (state) => state.acount.token,

        getCustomers: (state) => state.customers,

        getAcountRolesIds: (state) => state.acount.rols_ids,

        getArticlesIndexed: (state) => state.articles_index,

        getProducts: (state) => state.products,

        getAcount: (state) => state.acount,

        getMemberDiscount: (state) => {
            if (state.authenticated) {
                return state.acount.user.customer.discount;
            }
            return 0;
        },

        getCategories: (state) => state.categories,

        getParentCategories: (state) =>
            state.categories.filter(
                (category) => category.category_id === null
            ),

        getTypeOfFinishes: (state) => state.type_of_finishes,

        getArticlesWhereCategoryId: (state) => (category_id) => {
            return state.articles.filter((article) =>
                article.categories.includes(category_id)
            );
        },

        getProductsWhereCategoryId: (state) => (category_id) => {
            return state.products.filter(
                (product) => product.category_id == category_id
            );
        },

        getArticlersWhereId: (state, getters) => (articles_ids) => {
            return getters.getArticles.filter((article) =>
                articles_ids.includes(article.id)
            );
        },

        getProductsWhereId: (state, getters) => (products_ids) => {
            return getters.getProducts.filter((product) =>
                products_ids.includes(product.id)
            );
        },
    },

    mutations: {
        SET_TOKEN(state, token) {
            state.acount.token = token;
        },

        SET_ROLES_IDS(state, rols_ids) {
            state.acount.rols_ids = rols_ids;
        },

        SET_USER(state, user) {
            state.acount.user = user;
            state.authenticated = Boolean(user);
        },

        SET_TOKEN_REFRES_DIALOG(state, value) {
            state.ui.tokenRefreshDialog = value;
        },

        SET_ARTICLES(state, articles) {
            state.articles = articles;
        },

        SET_ARTICLES_INDEXED(state, articles_index) {
            state.articles_index = articles_index;
        },

        SET_PRODUCTS(state, products) {
            state.products = products;
        },

        SET_PURCHACE_ORDERS(state, purchaceorders) {
            state.purchaceorders = purchaceorders.reverse();
            state.ui.purchaceordersGeting = false;
        },

        SET_PURCHACE_ORDER(state, purchaceorder) {
            state.purchaceorders.push(purchaceorder);
        },

        SET_CUSTOMERS(state, customers) {
            state.customers = customers;
        },

        SET_COLORS(state, colors) {
            state.colors = colors;
        },

        SET_CUSTOMER(state, customer) {
            state.customers.push(customer);
        },

        SET_SHIPPING_METHODS(state, shipping_methods) {
            state.shipping_methods = shipping_methods;
            state.ui.getingShippingMethods = false;
        },

        SET_TYPE_OF_FINISHES(state, type_of_finishes) {
            state.type_of_finishes = type_of_finishes;
        },

        SET_SHIPPING_METHOD(state, shipping_method) {
            state.shipping_methods.push(shipping_method);
        },

        SET_CRITERION(state, criterion) {
            state.criterion = criterion;
        },

        SET_RESULTS(state, results) {
            state.results = results;
        },

        SET_FILTERS(state, filters) {
            state.filters = filters;
        },

        SET_CATEGORIES(state, categories) {
            state.categories = categories;
        },

        SET_SALES_ORDER_LAST_ID(state, sales_order_last_id) {
            state.sales_order_last_id = sales_order_last_id;
        },
    },

    actions: {
        async startApp({ commit }) {
            try {
                let session = JSON.parse(localStorage.getItem("session"));

                let resp = await axios.get(
                    `${process.env.VUE_APP_API_SERVER}/auth/user`, {
                        headers: {
                            Authorization: `Bearer ${session.token}`,
                        },
                    }
                );

                commit("SET_TOKEN", session.token);

                commit("SET_USER", resp.data.data);

                commit(
                    "SET_ROLES_IDS",
                    resp.data.data.roles.map((rol) => rol.id)
                );
            } catch (error) {
                // commit("SET_TOKEN_REFRES_DIALOG", true);
                // localStorage.removeItem("session");
                // return (location = "https://spa.pinturasacuario.mx");
            }
        },

        setTokenRefreshDialog({ commit }, value) {
            commit("SET_TOKEN_REFRES_DIALOG", value);
        },

        async getProducts({ commit, state }) {
            try {
                state.ui.productsGeting = true;

                let resp = await axios.get(
                    `${process.env.VUE_APP_API_SERVER}/store/product`, {
                        headers: {
                            Authorization: `Bearer ${state.acount.token}`,
                        },
                    }
                );

                commit("SET_PRODUCTS", resp.data.data);
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            } finally {
                state.ui.productsGeting = false;
            }
        },

        async getArticles({ commit, state }, customer_id) {
            try {
                state.ui.articlesGeting = true;

                let endpoint = `${process.env.VUE_APP_API_SERVER}/store/article`;
                if (customer_id) {
                    endpoint = `${process.env.VUE_APP_API_SERVER}/auth/customer/${customer_id}/article`;
                }

                let resp = await axios.get(endpoint, {
                    headers: {
                        Authorization: `Bearer ${state.acount.token}`,
                    },
                });

                let articles = resp.data.data.map((article) => {
                    let complement = {
                        price: article.base_price,
                        discount: article.base_discount,
                    };

                    if (article.pivot) {
                        complement = {
                            ...complement,

                            preferential_price: article.pivot.preferential_price,
                            preferential_discount: article.pivot.preferential_discount,

                            price: article.pivot.preferential_price,
                            discount: article.pivot.preferential_discount,
                        };
                    }

                    return {
                        ...article,
                        ...complement,
                    };
                });
                commit("SET_ARTICLES", articles);

                commit(
                    "SET_ARTICLES_INDEXED",
                    articles.reduce((acc, article) => {
                        acc[article.article_id ? article.article_id : article.id] = article;
                        return acc;
                    }, [])
                );
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            } finally {
                state.ui.articlesGeting = false;
            }
        },

        async getShippingMethods({ commit }) {
            if (this.state.shipping_methods.length === 0) {
                try {
                    this.state.ui.getingShippingMethods = true;

                    let resp = await axios.get(
                        `${process.env.VUE_APP_API_SERVER}/shippingmethod`
                    );

                    commit("SET_SHIPPING_METHODS", resp.data.data);
                } catch (error) {
                    EventBus.$emit("Error", { error: error, errorsShow: true });
                }
            }
        },

        async getCategories({ commit }) {
            if (this.state.categories.length === 0) {
                try {
                    this.state.ui.getingCategories = true;

                    let resp = await axios.get(
                        `${process.env.VUE_APP_API_SERVER}/store/category`
                    );

                    commit("SET_CATEGORIES", resp.data.data);
                } catch (error) {
                    EventBus.$emit("Error", { error: error, errorsShow: true });
                }
            }
        },

        async getTypeOfFinishes({ commit }) {
            if (this.state.type_of_finishes.length === 0) {
                try {
                    this.state.ui.getingtype_of_finishes = true;

                    let resp = await axios.get(
                        `${process.env.VUE_APP_API_SERVER}/store/typeoffinishes`
                    );

                    commit("SET_TYPE_OF_FINISHES", resp.data.data);
                } catch (error) {
                    EventBus.$emit("Error", { error: error, errorsShow: true });
                }
            }
        },

        async getColors({ commit }) {
            if (this.state.colors.length === 0) {
                try {
                    this.state.ui.colorGeting = true;

                    let resp = await axios.get(
                        `${process.env.VUE_APP_API_SERVER}/store/color`
                    );

                    commit("SET_COLORS", resp.data.data);
                } catch (error) {
                    EventBus.$emit("Error", { error: error, errorsShow: true });
                }
            }
        },

        async getPurchaceOrders({ commit }) {
            try {
                this.state.ui.purchaceordersGeting = true;

                let resp = await axios.get(
                    `${process.env.VUE_APP_API_SERVER}/auth/customer/purchaceorder`, {
                        headers: {
                            Authorization: `Bearer ${this.state.acount.token}`,
                        },
                    }
                );

                commit("SET_PURCHACE_ORDERS", resp.data.data);
            } catch (error) {
                try {
                    switch (error.response.status) {
                        case 401:
                            commit("SET_TOKEN_REFRES_DIALOG", true);
                            break;
                        default:
                            EventBus.$emit("Error", {
                                error: error,
                                errorsShow: true,
                            });
                            break;
                    }
                } catch (e) {
                    EventBus.$emit("Error", {
                        error: error,
                        alertShow: true,
                    });
                }
            } finally {
                this.state.ui.purchaceordersGeting = false;
            }
        },

        setPurchaceOrder({ commit }, purchaceorder) {
            commit(purchaceorder);
        },

        async getCustomers({ commit, state }) {
            if (this.state.customers.length === 0) {
                try {
                    this.state.ui.getingCustomers = true;

                    let resp = await axios.get(
                        `${process.env.VUE_APP_API_SERVER}/auth/store/customer`, {
                            headers: {
                                Authorization: `Bearer ${state.acount.token}`,
                            },
                        }
                    );

                    commit("SET_CUSTOMERS", resp.data.data);
                } catch (error) {
                    EventBus.$emit("Error", { error: error, alertShow: true });
                } finally {
                    this.state.ui.getingCustomers = false;
                }
            }
        },

        setCustomer({ commit }, customer) {
            commit("SET_CUSTOMER", customer);
        },

        setShippingMethod({ commit }, shipping_method) {
            commit("SET_SHIPPING_METHOD", shipping_method);
        },

        search({ commit }, criterion) {
            let fuse = new Fuse(this.state.articles, {
                // isCaseSensitive: false,
                // includeScore: false,
                // shouldSort: true,
                // includeMatches: false,
                // findAllMatches: false,
                // minMatchCharLength: 1,
                // location: 0,
                // threshold: 0.6,
                // distance: 100,
                // useExtendedSearch: false,
                // ignoreLocation: false,
                // ignoreFieldNorm: false,
                keys: ["code", "description"],
            });

            let results = [];

            if (criterion) {
                results = fuse.search(criterion).map((result) => {
                    return {
                        ...result.item,
                    };
                });
            }

            commit("SET_CRITERION", criterion);

            commit("SET_RESULTS", results);

            EventBus.$emit("critetionChanged", criterion);
        },

        async logout({ commit }) {
            try {
                let resp = await axios.post(
                    `${process.env.VUE_APP_API_SERVER}/auth/logout`, {}, {
                        headers: {
                            Authorization: `Bearer ${this.state.acount.token}`,
                        },
                    }
                );

                localStorage.removeItem("session");

                commit("SET_TOKEN", null);

                commit("SET_USER", null);

                router.push({ name: "Login" });
            } catch (error) {
                EventBus.$emit("Error", { error: error, errorsShow: true });
            } finally {}
        },

        hasRol(context, rol_id_required) {
            return context.state.acount.rols_ids.includes(rol_id_required);
        },
    },

    modules: {
        cart,
    },
});